import { useAtomValue } from "jotai"
import { useEffect } from "react";
import { meetingStore } from "store/meetingStore";

export const useMeetingList = () => {
    const meetingListState = useAtomValue(meetingStore.meetingList.stateAtom);

    useEffect(() => {
        // 컴포넌트 언마운트 시 상태 초기화
        return () => {
            meetingStore.meetingList.onDefault();
        }
    }, []);

    return {
        status: meetingListState.status,
        data: meetingListState.data,
        error: meetingListState.error
    };
}

export const useMeetingDetail = () => {
    const meetingDetailState = useAtomValue(meetingStore.meetingDetail.stateAtom);

    useEffect(() => {
        return () => {
            meetingStore.meetingDetail.onDefault();
        }
    }, []);

    return {
        status: meetingDetailState.status,
        data: meetingDetailState.data,
        error: meetingDetailState.error
    };
}

export const useCreateMeeting = () => {
    const createMeetingState = useAtomValue(meetingStore.createMeeting.stateAtom);

    useEffect(() => {
        return () => {
            meetingStore.createMeeting.onDefault();
        }
    }, []);

    return {
        status: createMeetingState.status,
        data: createMeetingState.data,
        error: createMeetingState.error
    };
}

export const useMeetingMembers = () => {
    const meetingMembersState = useAtomValue(meetingStore.meetingMembers.stateAtom);

    useEffect(() => {
        return () => {
            meetingStore.meetingMembers.onDefault();
        }
    }, []);

    return {
        status: meetingMembersState.status,
        data: meetingMembersState.data,
        error: meetingMembersState.error
    };
}

export const useJoinMeetingByCode = () => {
    const joinMeetingByCodeState = useAtomValue(meetingStore.joinMeetingByCode.stateAtom);

    useEffect(() => {
        return () => {
            meetingStore.joinMeetingByCode.onDefault();
        }
    }, []);

    return {
        status: joinMeetingByCodeState.status,
        data: joinMeetingByCodeState.data,
        error: joinMeetingByCodeState.error
    };
}
